import { Appointment, AppointmentID } from "./Appointment";
import { Car, CarID } from "./Car";
import { CommunicationAgreement } from "./CheckIn";
import { Customer, CustomerID } from "./Customer";
import { DealerLocationID } from "./DealerLocation";
import { KioskLabel, KioskLabelNumber } from "./Kiosk";
import { NoteSuggestion } from "./NoteSuggestion";
import { User, UserID } from "./User";

export type KioskCommunicationID = number;

export type KioskCommunicationEventID = number;

export type KioskRemarkID = number;

export type KioskAgreedInterventionID = number;

export enum KIOSK_COMMUNICATION_STATUSES {
  CheckInOpened = 1,
  CheckInAnswered = 2
}

export enum KIOSK_COMMUNICATION_EVENT_TYPES {
  CheckInOpened = 1,
  CheckInAnswered = 2,
  LabelDetached = 3
}

export interface KioskCommunication {
  created_on: string;
  updated_on: string;
  id: KioskCommunicationID;
  status: KIOSK_COMMUNICATION_STATUSES; // Current status of the kiosk communication
  customer_id: CustomerID | null; // Customer who this kioskCommunication is for
  appointment_id: AppointmentID; // Appointment from which this kioskCommunication originated from
  car_id: CarID; // Car from which the Appointment is for
  dealer_location_id: DealerLocationID; // DealerLocation from which the Appointment is from
  customer?: Customer;
  appointment?: Appointment;
  car?: Car;
  events?: KioskCommunicationEvent[];
  agreements?: CommunicationAgreement[]; // CommunicationAgreements that have been agreed
  agreed_interventions?: KioskAgreedIntervention[]; // Slice of agreed interventions
  remark?: KioskRemark; // Customer provided a remark on the communication
  labels?: KioskLabel[]; // Embedded Kiosk Labels when the Customer is sent the Communication
  note_suggestions?: NoteSuggestion[]; // Embedded Note Suggestions so that customer can choose from it for the parking note during kiosk checkin
  parking_note?: string; // Embedded Parking Note when the Customer is sent the Communication
}

export interface KioskCommunicationEvent {
  created_on: string;
  updated_on: string;
  id: KioskCommunicationEventID;
  type: KIOSK_COMMUNICATION_EVENT_TYPES; // Type of the kioskCommunicationEvent
  correct_phone: string; // Correct phone number of the customer
  customer_name: string; // Name of the customer
  customer_signature: string; // Signature of the customer
  kiosk_name: string | null; // Name of the Kiosk that was used for this event
  kiosk_label_number: KioskLabelNumber | null; // Label of the Kiosk that was used for this event
  user_id: UserID | null; // User Identifier that triggered this event
  kiosk_communication_id: KioskCommunicationID; // Identifier of the kiosk Communication
  kiosk_agreed_interventions?: KioskAgreedIntervention[];
  user?: User;
}

export interface KioskRemark {
  created_on: string;
  updated_on: string;
  id: KioskRemarkID;
  description: string; // Reason for the remark
  customer_name: string; // Name entered by the customer while leaving the remark.
  receptionist_handled: boolean; // Receptionist has handled the remark
  visible_in_dashboard: boolean; // The receptionist can see this remark and handle it
  visible_to_mechanic: boolean; // The mechanic can see this remark and can work on it
  kiosk_communication_id: KioskCommunicationID; // The KioskCommunication that the remark originates rom
  appointment_id?: AppointmentID; // Appointment Identifier
}

export interface KioskAgreedIntervention {
  created_on: string;
  id: KioskAgreedInterventionID;
  title: string; // Title of the agreed intervention
  description: string; // Description of the agreed intervention
  price: number; // Price of the agreed intervention
  vat: number | null; // VAT of the agreed intervention
  kiosk_communication_id: KioskCommunicationID; // Kiosk Communication ID
}
